import React, { useMemo } from 'react';

export default function ChallengePreview({ data = {} }) {
  const { 
    title = 'Titre du défi', 
    difficulty = 'easy', 
    rewardXP = 0, 
    duration = 0, 
    sportType = 'Général', 
    targetValue = 0 
  } = data;

  // difficulty label intentionally hidden in preview
  
  // Dynamic progress calculation
  const progress = useMemo(() => {
    return Math.min(100, Math.round((targetValue ? (targetValue / Math.max(1, targetValue)) : 0) * 100));
  }, [targetValue]);

  return (
    <div className="cp-card">
      <div className="cp-header">
        <div className="cp-title" title={title}>
          {title || 'Titre du défi'}
        </div>
      </div>

      <div className="cp-meta">
        <div>
          <span style={{ fontSize: '1.2em' }}>⭐</span>
          <strong>{rewardXP}</strong> XP
        </div>
        <div>
          <span style={{ fontSize: '1.2em' }}>📅</span>
          {duration ? `${duration} jour${duration > 1 ? 's' : ''}` : 'Durée non définie'}
        </div>
        <div>
          <span style={{ fontSize: '1.2em' }}>🏆</span>
          {sportType}
        </div>
      </div>

      <div className="cp-progress">
        <div className="cp-progress-label">Progression estimée</div>
        <div className="cp-progress-bar">
          <div className="cp-progress-fill" style={{ width: `${progress}%` }} />
        </div>
        <div style={{ fontSize: '0.8rem', color: '#9ca3af', marginTop: '6px', textAlign: 'right' }}>
          {progress}% complété
        </div>
      </div>

      <div style={{ marginTop: '16px', padding: '12px', background: 'rgba(14, 165, 164, 0.04)', borderRadius: '10px', fontSize: '0.85rem', color: '#6b7280', lineHeight: '1.5' }}>
        <strong style={{ color: '#0f172a', display: 'block', marginBottom: '4px' }}>💡 Conseil</strong>
        Complétez les informations pour générer un aperçu en direct.
      </div>
    </div>
  );
}
